import { Injectable } from '@angular/core';
import { environment } from '@environments/environment';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class NotificationService {

  constructor(private http: HttpClient) { }

  getNotification(subjectid) {
    return this.http.get<any>(environment.apiUrl + 'notifications/config/' + subjectid);
  }

  saveNotification(data) {
    return this.http.post<any>(environment.apiUrl + 'notifications/config', data);
  }

  updateNotification(data) {
    return this.http.put<any>(environment.apiUrl + 'notifications/config', data);
  }

}
